import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";

export default class Insertpresent10 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      openinsdoc: true,
      showphoto: false,
      ShowfileUpload: [],
      fileimage: [],
      fileimage_name: null,
      tpatscore: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openinsertdocument = this.openinsertdocument.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
      });

    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/student_insertpresent10/ShowfileUpload/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((res) => {
        if (res.data.length !== 0) {
          if (res.data[0]["PAT5_FILE"] === null || res.data[0]["PAT5_FILE"] === 0) {
            this.setState({ openinsdoc: true });
            this.setState({ showphoto: false });
            this.setState({ ShowfileUpload: [] });
          } else {
            this.setState({ openinsdoc: false });
            this.setState({ showphoto: true });
            this.setState({ ShowfileUpload: res.data });
            this.setState({ tpatscore: res.data[0].PAT5_SCORE });
          }
        }
      });
  }

  handleChange(event) {
    event.preventDefault();
    var namefile = event.target.files[0].name;
    namefile = namefile.split(".");
    this.setState({
      [event.target.name + "_name"]: localStorage.getItem("ID_LOGIN") + "." + namefile[1],
    });
    this.setState({ [event.target.name]: event.target.files[0] });
  }

  handleReset(event) {
    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/student_insertpresent10/ShowfileUpload/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((res) => {
        if (res.data.length !== 0) {
          if (res.data[0]["PAT5_FILE"] === null || res.data[0]["PAT5_FILE"] === 0) {
            this.setState({ openinsdoc: true });
            this.setState({ showphoto: false });
            this.setState({ ShowfileUpload: [] });
          } else {
            this.setState({ openinsdoc: false });
            this.setState({ showphoto: true });
            this.setState({ ShowfileUpload: res.data });
          }
        }
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData();
    formData.append("UserID", localStorage.getItem("ID_LOGIN"));
    formData.append("typedocument", "1");
    formData.append("file", this.state.fileimage);
    formData.append("tpatscore", this.state.tpatscore);

    axios
      .post(
        "https://admission.kpru.ac.th/admission2017/student_insertpresent10/fileUpload/",
        formData
      )
      .then((res) => {
        axios
          .get(
            "https://admission.kpru.ac.th/admission2017/student/loadpresent/" +
              localStorage.getItem("ID_LOGIN")
          )
          .then((respone) => {
            this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
          });

        axios
          .get(
            "https://admission.kpru.ac.th/admission2017/student_insertpresent10/ShowfileUpload/" +
              localStorage.getItem("ID_LOGIN")
          )
          .then((res) => {
            if (res.data.length !== 0) {
              if (res.data[0]["PAT5_FILE"] === null || res.data[0]["PAT5_FILE"] === 0) {
                this.setState({ openinsdoc: true });
                this.setState({ showphoto: false });
                this.setState({ ShowfileUpload: [] });
              } else {
                this.setState({ openinsdoc: false });
                this.setState({ showphoto: true });
                this.setState({ ShowfileUpload: res.data });
              }
            }
          });
      });
  }

  openinsertdocument(event) {
    this.setState({ document_id: event.target.value });
    this.setState({ openinsdoc: true });
    if (event.target.value === "0") {
      axios
        .get(
          "https://admission.kpru.ac.th/admission2017/student_insertpresent10/fileUploadNot/" +
            localStorage.getItem("ID_LOGIN")
        )
        .then((res) => {
          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Present`;
        });
    }
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>
            ข้อมูลผลคะแนน TPAT 5 (เฉพาะหลักสูตรครุศาสตรบัณฑิตและหลักสูตรควบ 2 ปริญญา)
            มหาวิทยาลัยราชภัฏกำแพงเพชร
          </title>
          <meta
            name="description"
            content="ข้อมูลผลคะแนน TPAT 5 (เฉพาะหลักสูตรครุศาสตรบัณฑิตและหลักสูตรควบ 2 ปริญญา) มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข้อมูลผลคะแนน TPAT 5 (เฉพาะหลักสูตรครุศาสตรบัณฑิตและหลักสูตรควบ 2 ปริญญา) มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>

          <MDBRow>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
            <MDBCol lg="10" md="12" sm="12">
              <MDBCard>
                <MDBCardBody>
                  <MDBContainer fluid>
                    <MDBRow>
                      <MDBCol>
                        <MDBCardTitle>
                          ข้อมูลผลคะแนน TPAT 5 (เฉพาะหลักสูตรครุศาสตรบัณฑิตและหลักสูตรควบ 2 ปริญญา)
                        </MDBCardTitle>
                        <MDBCardText>
                          <MDBRow>
                            <MDBCol lg="12" md="12" sm="12">
                              {this.state.openinsdoc ? (
                                <>
                                  <form onSubmit={this.handleSubmit}>
                                    <div className="form-outline">
                                      <label className="form-label" for="fileimage">
                                        ไฟล์เอกสาร <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <br />
                                      <label for="fileimage" className="custom-file-upload">
                                        <i className="fa fa-cloud-upload"></i> เลือกไฟล์ที่ต้องการ
                                        *.pdf
                                      </label>
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="fileimage"
                                        name="fileimage"
                                        accept="application/pdf"
                                        onChange={this.handleChange}
                                        required
                                      />{" "}
                                      <span>{this.state.fileimage_name}</span>
                                      <br />
                                      <label className="form-label" for="tpatscore">
                                        ผลคะแนน TPAT5 <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        className="form-control"
                                        id="tpatscore"
                                        name="tpatscore"
                                        type="number"
                                        onChange={(e) => {
                                          this.setState({ tpatscore: e.target.value });
                                        }}
                                        required
                                      />{" "}
                                      <br />
                                    </div>
                                    {this.state.fileimage.length !== 0 ? (
                                      <>
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-rounded btn-md mt-2"
                                        >
                                          อัพโหลดไฟล์
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          type="submit"
                                          className="btn btn-primary btn-rounded btn-md mt-2"
                                          disabled
                                        >
                                          อัพโหลดไฟล์
                                        </button>
                                      </>
                                    )}
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-rounded btn-md mt-2"
                                      onClick={this.handleReset}
                                    >
                                      ยกเลิก
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary btn-rounded btn-md mt-2"
                                      value="0"
                                      onClick={this.openinsertdocument}
                                    >
                                      คลิกหากไม่มีไฟล์เอกสาร
                                    </button>
                                  </form>
                                </>
                              ) : (
                                <></>
                              )}

                              {this.state.showphoto ? (
                                <>
                                  <table className="table table-hover">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>ไฟล์</th>
                                        <th>คะแนน</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.ShowfileUpload.map((data, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              {data.PAT5_FILE !== null ? (
                                                <>
                                                  <a
                                                    href={
                                                      "https://admission.kpru.ac.th/admission2017/" +
                                                      data.PAT5_FILE
                                                    }
                                                    target="_blank"
                                                    className="btn btn-success btn-md"
                                                    role="button"
                                                  >
                                                    ดูไฟล์เอกสาร
                                                  </a>
                                                  <button
                                                    type="button"
                                                    className="btn btn-warning btn-md"
                                                    value="1"
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    แก้ไขไฟล์เอกสาร
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                              {data.PAT5_FILE === null ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    className="btn btn-info btn-md"
                                                    value="1"
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    มีไฟล์เอกสาร
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="btn btn-danger btn-md"
                                                    value="0"
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    ไม่มีไฟล์เอกสาร
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                            <td>{this.state.tpatscore}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </>
                              ) : (
                                <></>
                              )}
                              <div>
                                <a
                                  href={`${process.env.REACT_APP_BASENAME || ""}/Present`}
                                  className="btn btn-success btn-block"
                                  role="button"
                                >
                                  คลิกเพื่อกลับหน้าหลักเพื่อพิมพ์ใบรายงานตัว
                                </a>
                              </div>
                            </MDBCol>
                          </MDBRow>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </MDBContainer>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
          </MDBRow>
        </MDBContainer>
      </>
    );
  }
}


